import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { ConfirmDialogComponent } from './confirm-dialog.component';
import { ConfirmDirective } from './confirm.directive';
import { ConfirmService } from './confirm.service';

const sharedComponents = [ConfirmDialogComponent, ConfirmDirective];

@NgModule({
    declarations: [sharedComponents],
    imports: [CommonModule, FormsModule],
    exports: [sharedComponents],
    providers: [ConfirmService],
})
export class ConfirmDialogModule {}
